import { render, staticRenderFns } from "./DeleteSolidIcon.vue?vue&type=template&id=ebf5b404&"
import script from "./DeleteSolidIcon.vue?vue&type=script&lang=js&"
export * from "./DeleteSolidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports